import { render, staticRenderFns } from "./DeResetButton.vue?vue&type=template&id=ae4537a2&scoped=true&"
import script from "./DeResetButton.vue?vue&type=script&lang=js&"
export * from "./DeResetButton.vue?vue&type=script&lang=js&"
import style0 from "./DeResetButton.vue?vue&type=style&index=0&id=ae4537a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4537a2",
  null
  
)

export default component.exports